import React, { useEffect } from 'react'
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { AbstructVar } from '../../../components/general/general-component/abstruct-component/AbstructVar';
import { AbstructLang } from '../../../components/general/general-component/abstruct-component/AbstructLang';
import { Form } from '../../../components/general/general-component/abstruct-component/AbstructForm';
import { VariableExpenses } from './VariableExpenses';

function EditExpenses({arr, open, setOpen }) {
    let { mode, dispatch,langLocal } = AbstructVar()
    const { translate } = AbstructLang()
    const { state, setStateCustom,setState, setLoad } = VariableExpenses()
    const Submit = e => {
        e.preventDefault()
        //dispatch(postUser(state, setLoad))
    }
    useEffect(()=>{
        setState((prevState) => ({
            ...prevState,
            invoice_number: arr.invoice_number,
            description: arr?.description,
            date: arr?.date,
            notes: arr?.notes,
            statement_id: arr?.statement?.id,
        }));
    },[])
    const formFields = [
        { name: 'invoice_number', label: 'invoice_number', type: 'number', inputType: 'text', iconType: "pencil" },
        { name: 'invoice_image', label: 'invoice_image', type: 'file', inputType: 'file', iconType: "pencil" },
        { name: 'delivery_receipt_image', label: 'delivery_receipt_image', type: 'file', inputType: 'file', iconType: "pencil" },
        { name: 'description', label: 'description', type: 'text', inputType: 'text', iconType: "pencil" },
        { name: 'date', label: 'date', type: 'date', inputType: 'text', iconType: "pencil" },
        { name: 'notes', label: 'notes', type: 'text', inputType: 'text', iconType: "pencil" },
        { name: 'amount', label: 'amount', type: 'number', inputType: 'text', iconType: "pencil" },
        {
            name: "statement_id", label: "statements", type: "text", inputType: 'one_select', iconType: "statement",
            options: [{ value: 1, label: 'statement 1' }, { value: 2, label: 'statement 2' }],
        },
    ];
    return (
        <RModal
            open={open}
            onClose={() => {
                setOpen(false);
            }}
            center
            classNames={{
                modal: `popupR`,
            }}
            focusTrapped={false}
            overlayOpacity={0.5}
        >
            <div className={`div_popup ${mode === 'dark' ? "darkPopUp" : "lightPopUp"}`}>
                <div className={`div_title_popup ${mode === 'dark' ? "darktoppopup" : "lighttoppopup"}`} >
                    <p className={`title_popup ${mode === 'dark' ? "darktext" : "lighttext"}`}  >{translate('edit_expenses')}</p>
                </div>
                <Form langLocal={langLocal} fields={formFields} handleSubmit={Submit} state={state} setStateCustom={setStateCustom} buttonLabel="add" />
            </div>
        </RModal>
    )
}

export default EditExpenses

